import { isServer } from 'lit';

class InputCheckedController {
  constructor({ host }) {
    this.checked = false;
    this.host = host;
    this.hostElement = host;
    this.host.addController(this);
    this._observer = new MutationObserver(this._observerCallback.bind(this));
  }
  get _input() {
    return this.hostElement.querySelector("input");
  }
  get _siblings() {
    if (this._input?.name && this._input.name.length > 0) {
      return Array.from(
        document.querySelectorAll(`input[type=${this._input.type}][name=${this._input.name}]`)
      ).filter((inp) => !inp.isEqualNode(this._input));
    }
    return [];
  }
  hostConnected() {
    if (!isServer && this._input) {
      this.checked = this._input.checked;
      this._observer.observe(this._input, { attributeFilter: ["checked"], attributes: true });
      this._input.addEventListener("change", this._handleInputChange.bind(this));
    }
  }
  hostDisconnected() {
    if (this._input) {
      this._observer.disconnect();
      this._input.removeEventListener("change", this._handleInputChange.bind(this));
    }
  }
  _handleInputChange(e) {
    const input = e.target;
    const { checked, type } = input;
    if (checked) {
      input.setAttribute("checked", "checked");
      if (type === "radio") {
        this._removeCheckedAttributeFromSiblings();
      }
    }
    this.checked = checked;
    this.host.requestUpdate();
  }
  _observerCallback(mutationList) {
    for (const mutation of mutationList) {
      const input = mutation.target;
      this.checked = input.hasAttribute("checked");
      this.host.requestUpdate();
    }
  }
  _removeCheckedAttributeFromSiblings() {
    this._siblings.forEach((inp) => inp.removeAttribute("checked"));
  }
}

export { InputCheckedController };
